import Devices from './Devices';
import { Eft } from '../../models';

class Efts extends Devices {
    constructor() {
        super({
            model: Eft,
            entryPoint: 'efts',
            resource:   'eft',
            resources:  'efts'
        });
    }
}

const EftsApi = new Efts();

export default EftsApi;
